import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import FilterButton from '../../../SHARED/components/filterbutton/filterbutton.component';
import { getGenreFilters } from '../../../SHARED/actions/filters.actions';
import { updateFavoriteGenres } from '../../../SHARED/actions/editprofile.actions';

class EditFavoriteGenres extends Component {

    constructor(props){
        super(props);
        this.state = {
            fav_genres: []
        }
    }
    componentWillMount(){
        this.props.getGenreFilters();
        this.setState({fav_genres: this.props.favGenres})
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.favGenres) {
            this.setState({fav_genres: nextProps.favGenres});
        }
    }

    handleChanges = (value) => {
        if(this.state.fav_genres.includes(value)){
            let arr = this.state.fav_genres.filter(item => item !== value)
            this.setState({fav_genres: arr})
        }
        else{
            this.state.fav_genres.push(value)
        }
    }

    showGenres = () => {
        if (this.state.fav_genres)
        {
            return this.props.genres.map((gender, i) => {
                return <Fragment key={i}>
                    {this.state.fav_genres.includes(gender.id) ?
                        <FilterButton selected={true} interactivity={true} handleInteractivity={() => this.handleChanges(gender.id)} appearance={'styled'} label={gender.name} onclick={this.show} /> :
                        <FilterButton selected={false} interactivity={true} handleInteractivity={() => this.handleChanges(gender.id)} appearance={'styled'} label={gender.name} />}
                    </Fragment> 
            })
        }
    }

    save = () => {
        this.props.updateFavoriteGenres(this.state);
    }

    render() {
        return (
            <Fragment>
                <div className="favorite-genres">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="col-lg-5">
                                <div className="edit-profile-item-header">
                                    <span className="profile-favorite">Selectează genurile tale preferate</span>
                                </div>
                                {this.showGenres()}
                            </div>
                        </div>
                        <div className="col-lg-12 save">
                            <button type="submit" className="save-button" onClick={this.save}>Salvează</button>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    genres: state.filters.film_genre
})

export default connect(mapStateToProps, {getGenreFilters, updateFavoriteGenres})(EditFavoriteGenres);


// WEBPACK FOOTER //
// ./src/FO/components/editfavoritegenres/editfavoritegenres.component.js